import { EnvironmentConfig } from './IEnvironment';

export const environment: EnvironmentConfig = {
  production: false,
  psPdfKey: null,
  baseUrl: 'https://vasdevapi.wesco.com/',
  vasUrl: 'https://vasdev.wesco.com',
  msalConfig: {
    auth: {
      clientId: '2d21ac43-6d27-4a23-811e-efec80e3d69c',
      authority: 'https://login.microsoftonline.com/381d31b0-f4b9-4f22-a0dd-92488db3eb82',
    },
    system: {
      allowRedirectInIframe: true,
    },
  },
  apiConfig: {
    scopes: ['1504c768-730e-4869-a457-797894195185/.default'],
    uri: '',
  },
  allowedIframeOrigin: [
    'https://vassit.wesco.com',
    'https://vasdev.wesco.com',
    'https://devsales2-wesco.crm.dynamics.com',
    'https://sitpilot2-wesco.crm.dynamics.com',
    'https://sitpilot-wesco.crm.dynamics.com',
    'https://uat-wesco.crm.dynamics.com',
  ],
};
